<template>
  <div id="app">
    <MenuHorizontal v-if="$route.meta.menu" />
    <router-view role="main" />
  </div>
</template>

<script setup>
import { watch } from "vue";
import { useRouter } from "vue-router";
import MenuHorizontal from "@/components/MenuHorizontal.vue";
import { useGlobalStore } from "@/store/useGlobalStore";
import empresaService from "@/services/empresaService";

const store = useGlobalStore();
const router = useRouter();

// Carrega empresa em background sem bloquear navegação
async function carregarEmpresa() {
  if (!store.cnpjLogado || store.empresaLogada?.idEmpresa) return;
  try {
    const empresa = await empresaService.buscarEmpresa(store.cnpjLogado);
    if (empresa) {
      store.definirObjetoEmpresaLogada(
        Array.isArray(empresa) ? empresa[0] : empresa,
      );
    }
  } catch (e) {
    if (e?.response?.status === 401) {
      store.desautenticar();
      router.push("/login");
    }
    // Erro de rede — ignora silenciosamente, páginas tratam o estado vazio
  }
}

// Quando a empresa carrega mas os menus ainda estão vazios (ex: reload rápido onde
// o guard chegou antes do App.vue terminar), tenta buscar os menus uma segunda vez.
// Se a API falhar, o catálogo estático garante que o menu apareça.
watch(
  () => store.empresaLogada?.idEmpresa,
  async (idEmpresa) => {
    if (!idEmpresa || store.menusCarregadosDaApi) return;
    try {
      const { default: planosService } = await import(
        "@/services/planosService"
      );
      const itens = await planosService.buscarMenuAcessos(store.cnpjLogado);
      if (Array.isArray(itens) && itens.length > 0) {
        store.definirMenus(itens);
      } else {
        store.construirMenusDeFallback();
      }
    } catch {
      store.construirMenusDeFallback();
    }
  },
);

// Dispara ao montar e quando o cnpj mudar (login)
carregarEmpresa();
watch(() => store.cnpjLogado, carregarEmpresa);
</script>

<style>
#app {
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  min-height: 100vh;
  background-color: var(--color-bg);
}
</style>
